/*
 * @Author: wangliang
 * @LastEditTime: 2023-08-22 17:25:41
 * @Description:
 * @LastEditors: wangliang wangliang@wiz.top
 */
import cloudRender from './index'
import {
  POINT_SELETE_COLLECTION,
  MOVE_COLLECTION,
  MEASURE_COLLECTION,
  UNALLOW_COEXIST_COM,
  ROAM_COLLECTION,
} from './basicCode'
// import { setClipBox, cancelClip } from './clip'
import setModelVisible from './modelTree'
/** ----- 静态数据 end----- */

// 当前激活的tag信息 （储存到本地）
let activeTagData = {
  rightComList: [], // 右侧弹框列表
  leftComList: [], // 左侧弹框列表
  activeTags: [], // 目前激活的功能列表
  basicTags: [], // 激活的基础功能
}

// key 为索引 0 递增， value 为当前类型集合
const OPERATION_COLLECTION = {
  // 只通过code调用实例 开启、关闭操作
  0: [...POINT_SELETE_COLLECTION, ...MOVE_COLLECTION, ...MEASURE_COLLECTION, ...ROAM_COLLECTION],
  1: [],
}
// 工具类，不需要清除状态的
const toolTabBar = [
  'system.Move',
  'system.Rotate',
  'system.ToolFixedObservation',
  'system.Scale',
  'system.ToolMLine',
  'system.ToolMPoint',
  'system.ToolVertical',
  'system.Toolp2p',
  'system.ToolAngle',
  'system.ToolArea',
  'system.ToolWheelBase',
  'system.Pickup',
  'system.walk.first',
  'system.walk.fixView',
]
// 不需要激活态的节点
const unActiveNode = [
  'system.ToolHideModelSpaceSwap',
  'system.ToolHideModel',
  'system.ToolShowModel',
  'system.ToolShowAll',
]

/**
 * @description: 根据code找到对应索引
 * @param {*} code 激活功能编码
 * @return {*}
 */
const getOperationType = (code) => {
  return _.findIndex(Object.values(OPERATION_COLLECTION), (item) => {
    return _.includes(item, code)
  })
}

/**
 * @description: 销毁基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @return {*}
 */
const destroyCloseBasicTab = async (code, player) => {
  const operationType = getOperationType(code)
  switch (operationType) {
    case 0:
      const closeRes = await cloudRender.setTool(code, false, player)
      return closeRes
    default:
      break
  }
  return {}
}

const removeAcitveAblity = (unAllowCode, activeBasicList, player) => {
  // 删除当前code
  _.remove(activeBasicList, (activeCode) => {
    return _.eq(activeCode, unAllowCode)
  })
  // 清空当前code对应功能
  destroyCloseBasicTab(unAllowCode, player)
}

/**
 * @description: 销毁互斥基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const destroyUnallowBasicTab = (code, player, activeBasicList) => {
  // 不存在互斥功能
  if (_.isEmpty(UNALLOW_COEXIST_COM[code])) {
    return
  }
  _.forEach(UNALLOW_COEXIST_COM[code], (unAllowCode) => {
    const codeIndex = _.includes(activeBasicList, code)
    if (codeIndex) {
      removeAcitveAblity(unAllowCode, activeBasicList, player)
    }
  })
}

/**
 * @description: 初始化基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const initActiveBasicTab = async (code, player, activeBasicList) => {
  // 销毁互斥相关功能
  destroyUnallowBasicTab(code, player, activeBasicList)
  const operationType = getOperationType(code)
  switch (operationType) {
    case 0:
      const openRes = await cloudRender.setTool(code, true, player)
      return openRes
    default:
      break
  }

  return {}
}
/** ----- 静态数据 start----- */

// import { showPlayerSysSetting } from './modelSetting'
// import { setWalk } from './walk'
/**
 * @description: 移除tag列表
 * @param {Array} removeTags 当前需要移除的tag列表
 * @param {*} comList 当前激活的弹框组件列表
 * @return {*}
 */
const removeTagsStatus = (removeTags, comList, player) => {
  _.forEach(removeTags, (tag) => {
    // 处理弹框
    if (tag.direction) {
      comList.splice(_.findIndex(comList, ['component', tag.code]), 1)
      tag.direction === 'right'
        ? (activeTagData.rightComList = _.filter(activeTagData.rightComList, (el) => {
            return el.code !== tag.code
          }))
        : (activeTagData.leftComList = _.filter(activeTagData.leftComList, (el) => {
            return el.code !== tag.code
          }))
      if (activeTagData.rightComList.length === 1) {
        _.forEach(comList, (com) => {
          if (com.component === activeTagData.rightComList[0].code) {
            com.location = {
              top: '6.3rem',
              height: com.componentVal.maxHeight,
              float: com.componentVal.direction,
            }
          }
        })
      }
      if (activeTagData.leftComList.length === 1) {
        _.forEach(comList, (com) => {
          if (com.component === activeTagData.leftComList[0].code) {
            com.location = {
              top: '6.3rem',
              height: com.componentVal.maxHeight,
              float: com.componentVal.direction,
            }
          }
        })
      }
      // if (clipCom.includes(tag.code)) {
      //   cancelClip(window.player)
      // }
    }
    // if (tag.code === 'PlayerSetting') {
    //   showPlayerSysSetting(false)
    // }
    destroyCloseBasicTab(tag.code, player)
    if (toolTabBar.includes(tag.code)) {
      activeTagData.basicTags.splice(activeTagData.basicTags.indexOf(tag), 1)
    }
    // 处理modelViewData数据
    activeTagData.activeTags = _.filter(activeTagData.activeTags, (el) => {
      return el.code !== tag.code
    })
  })
  localforage.setItem('activeTagDetail', activeTagData)
  return _.map(activeTagData.activeTags, (item) => {
    return item.code
  })
}
/**
 * @description: 打开弹框组件时的处理
 * @param {*} tag 需要激活的tag
 * @param {*} comList 当前激活的弹框列表
 * @return {*}
 */
const tagClickByDialog = async (tag, comList) => {
  const componentData = {}
  let directionCom = []
  // 剖切
  // if (clipCom.includes(tag.code)) {
  //   const res = await setClipBox(tag)
  //   if (!res) return
  //   componentData = res
  // }
  if (tag.direction === 'right') {
    directionCom = activeTagData.rightComList || []
  } else if (tag.direction === 'left') {
    directionCom = activeTagData.leftComList || []
  }
  if (directionCom.length === 2) {
    removeTagsStatus([directionCom.shift()], comList)
  }
  if (_.isEmpty(directionCom)) {
    comList.push({
      id: tag.code,
      show: true,
      component: tag.code,
      componentVal: tag,
      componentData,
      location: {
        top: '6.3rem',
        height: tag.maxHeight,
        float: tag.direction,
      },
    })
  } else {
    let lastComHeight = ''
    _.forEach(comList, (com) => {
      if (directionCom[0].code === com.component) {
        com.location = {
          top: '6.3rem',
          height: `${50.8 - parseInt(tag.minHeight)}rem`,
          float: com.componentVal.direction,
        }
        lastComHeight = `${parseInt(com.location.top) + parseInt(com.location.height) + 1.5}rem`
      }
    })
    comList.push({
      id: tag.code,
      show: true,
      component: tag.code,
      componentVal: tag,
      componentData,
      location: {
        top: lastComHeight,
        height: tag.minHeight,
        float: tag.direction,
      },
    })
  }

  // if (tag.code === 'PlayerSetting') {
  //   showPlayerSysSetting(true)
  // }
  // 储存数据
  tag.direction === 'right'
    ? activeTagData.rightComList.push(tag)
    : activeTagData.leftComList.push(tag)
  activeTagData.activeTags = [...activeTagData.activeTags, tag]
  localforage.setItem('activeTagDetail', activeTagData)
}

/**
 * @description: 工具栏点击事件
 * @param {*} tag 当前激活的tag
 * @param {*} comList 当前显示的弹框组件列表
 * @return {*}
 */
const tagsClick = async (tag, comList, player) => {
  // 获取当前激活的功能
  activeTagData = (await localforage.getItem('activeTagDetail')) || activeTagData
  // 判断当前激活的功能是否有互斥
  if (!_.isEmpty(tag.unAllowCoexistCom)) {
    const removeTags = _.filter(activeTagData.activeTags, (activeTag) => {
      return tag.unAllowCoexistCom.includes(activeTag.code)
    })
    await removeTagsStatus(removeTags, comList, player)
  }
  if (_.find(activeTagData.activeTags, ['code', tag.code])) {
    // 重复点击的功能
    await removeTagsStatus([tag], comList, player)
  } else if (tag.direction) {
    // 弹框
    await tagClickByDialog(tag, comList)
  } else {
    // 当前激活的基础工具储存到本地
    if (toolTabBar.includes(tag.code)) {
      activeTagData.basicTags.push(tag.code)
      activeTagData.activeTags = [...activeTagData.activeTags, tag]
      localforage.setItem('activeTagDetail', activeTagData)
    }
    if (unActiveNode.includes(tag.code)) {
      setModelVisible(tag.code)
    } else {
      // 基础功能
      await initActiveBasicTab(tag.code, player, activeTagData.basicTags)
    }
  }
  activeTagData = (await localforage.getItem('activeTagDetail')) || activeTagData
  return _.map(activeTagData.activeTags, (item) => {
    return item.code
  })
}
export { initActiveBasicTab, destroyCloseBasicTab, tagsClick, removeTagsStatus }
